import {SelectOption} from '../components/select';
import {Department, EducationRequirement, EmploymentType, ExperienceLevel, OpportunityVisibility} from '../models/opportunity';

// Select options for opportunity form
export const departmentOptions: SelectOption[] = [
  {value: Department.ENGINEERING, label: 'Engineering'},
  {value: Department.DESIGN, label: 'Design'},
  {value: Department.PRODUCT, label: 'Product'},
  {value: Department.MARKETING, label: 'Marketing'},
  {value: Department.SALES, label: 'Sales'},
  {value: Department.HR, label: 'Human Resources'},
];

export const employmentTypeOptions: SelectOption[] = [
  {value: EmploymentType.FULL_TIME, label: 'Full-time'},
  {value: EmploymentType.PART_TIME, label: 'Part-time'},
  {value: EmploymentType.CONTRACT, label: 'Contract'},
  {value: EmploymentType.INTERNSHIP, label: 'Internship'},
];

export const experienceLevelOptions: SelectOption[] = [
  {value: ExperienceLevel.ENTRY, label: 'Entry Level (0-2 years)'},
  {value: ExperienceLevel.MID, label: 'Mid Level (3-5 years)'},
  {value: ExperienceLevel.SENIOR, label: 'Senior Level (6-10 years)'},
  {value: ExperienceLevel.LEAD, label: 'Lead Level (10+ years)'},
];

export const educationOptions: SelectOption[] = [
  {value: EducationRequirement.HIGH_SCHOOL, label: 'High School Diploma'},
  {value: EducationRequirement.BACHELORS, label: "Bachelor's Degree"},
  {value: EducationRequirement.MASTERS, label: "Master's Degree"},
  {value: EducationRequirement.PHD, label: 'PhD'},
  {value: EducationRequirement.NONE, label: 'No formal education required'},
];

export const visibilityOptions: SelectOption[] = [
  {value: OpportunityVisibility.PUBLIC, label: 'Public'},
  {value: OpportunityVisibility.PRIVATE, label: 'Private (Community-only)'},
];
